const nonce =
  document
    .querySelector('meta[name="csp-nonce"]')
    ?.getAttribute("content") || "";

if (nonce) {
  // Webpack maps this special variable to its runtime nonce. style-loader
  // reads it before inserting development <style> elements.
  // eslint-disable-next-line no-undef
  __webpack_nonce__ = nonce;
}
